import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  connect() {
    this.scrollToActiveLink();
  }

  scrollToActiveLink() {
    const activeLink = this.element.querySelector('.nav-link.active');
    if (activeLink) {
      this.scrollToLink(activeLink);
    }
  }

  scrollToLink(link) {
    const navbar = this.element;
    const rect = link.getBoundingClientRect();
    const navbarRect = navbar.getBoundingClientRect();
    const offset = rect.left - navbarRect.left;

    navbar.scrollTo({
      left: offset - navbar.clientWidth / 2 + rect.width / 2,
      behavior: 'smooth',
    });
  }

  handleClick(event) {
    event.preventDefault();

    const link = event.target;
    this.scrollToLink(link);
  }
}
